module.exports = __webpack_public_path__ + "media/images/riders/small/GREG_MINNAAR-7195da305d9d4ade2cdfed1053931491.png";